import { Button, Divider } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import {
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded
} from '@material-ui/icons';
import { Link as RRLink, useHistory } from 'react-router-dom';
import { HELP_TOPICS } from './HelpTopic';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    footer: {
      margin: theme.spacing(12, 0, 2, 0)
    },
    groupButton: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& > *': {
        textTransform: 'none',
        fontWeight: 'normal'
      }
    },
    previousButton: {
      marginRight: theme.spacing(0.5)
    },
    nextButton: {
      marginLeft: theme.spacing(0.5),
      textAlign: 'right'
    }
  })
);

interface FooterTopic {
  topic: string;
  link: string;
}

export default function HelpFooter() {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();

  const footerTopics: FooterTopic[] = [];
  function generateFooter() {
    HELP_TOPICS.forEach((helpTopic) => {
      helpTopic.subTopics.forEach((subTopic) => {
        footerTopics.push({ topic: t(subTopic.nameKey), link: subTopic.to });
      });
    });
  }
  generateFooter();

  const currentPath = history.location.pathname;
  const currentIndex = footerTopics.findIndex(
    (footerTopic) => footerTopic.link === currentPath
  );

  function findPreviousNextIndex(
    footerTopics: FooterTopic[],
    currentIndex: number
  ) {
    const L = footerTopics.length;
    const previousIndex = currentIndex - 1 >= 0 ? currentIndex - 1 : L - 1;
    const nextIndex = currentIndex + 1 < L ? currentIndex + 1 : 0;
    return { previousIndex, nextIndex };
  }
  const { previousIndex, nextIndex } = findPreviousNextIndex(
    footerTopics,
    currentIndex
  );

  function handleClick() {
    window['scrollTo']({ top: 0 });
  }

  return (
    <>
      <Divider className={classes.footer} />
      <div className={classes.groupButton}>
        <Button
          className={classes.previousButton}
          component={RRLink}
          to={footerTopics[previousIndex].link}
          size="large"
          startIcon={<KeyboardArrowLeftRounded />}
          onClick={handleClick}
        >
          {footerTopics[previousIndex].topic}
        </Button>
        <Button
          className={classes.nextButton}
          component={RRLink}
          to={footerTopics[nextIndex].link}
          size="large"
          endIcon={<KeyboardArrowRightRounded />}
          onClick={handleClick}
        >
          {footerTopics[nextIndex].topic}
        </Button>
      </div>
    </>
  );
}
